// Border radius scale for consistent rounded corners
export const borderRadius = {
  none: '0px',
  sm: '0.125rem',   // 2px
  base: '0.25rem',  // 4px
  md: '0.375rem',   // 6px
  lg: '0.5rem',     // 8px
  xl: '0.75rem',    // 12px
  '2xl': '1rem',    // 16px
  '3xl': '1.5rem',  // 24px
  full: '9999px',
};

// Border radius utility functions
export const getBorderRadius = (size) => {
  return borderRadius[size];
};

// CSS custom properties for border radius
export const generateBorderRadiusCSSVariables = () => {
  const variables = {};
  
  Object.entries(borderRadius).forEach(([key, value]) => {
    variables[`--border-radius-${key}`] = value;
  });
  
  return variables;
};

// Common border radius patterns
export const borderRadiusPatterns = {
  // Component patterns
  button: borderRadius.md,        // 6px - buttons and interactive elements
  card: borderRadius.lg,           // 8px - cards and containers
  input: borderRadius.md,          // 6px - form inputs
  modal: borderRadius.xl,          // 12px - modals and overlays
  
  // Layout patterns
  container: borderRadius.lg,      // 8px - main containers
  panel: borderRadius.md,          // 6px - side panels
  badge: borderRadius.full,        // fully rounded - badges and pills
  
  // Special patterns
  avatar: borderRadius.full,       // fully rounded - avatars
  thumbnail: borderRadius.md,      // 6px - image thumbnails
};

export default borderRadius;
